import { render, staticRenderFns } from "./CreateReportfaculty.vue?vue&type=template&id=ca9fcad0&"
import script from "./CreateReportfaculty.vue?vue&type=script&lang=js&"
export * from "./CreateReportfaculty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports